module.exports = __webpack_public_path__ + "static/media/bolt-splash.2b04241a.svg";